import LockupOnLight from "@/assets/golfrecruit-lockup-light.svg";
import LockupOnDark from "@/assets/golfrecruit-lockup-dark.svg";

/** The golfrecruit.ai lockup. The wordmark is custom artwork, so always use this instead of typing the name. */
export function BrandLogo({
  surface = "light",
  className = "h-11 w-auto",
}: {
  surface?: "light" | "dark";
  className?: string;
}) {
  return (
    <img
      src={surface === "dark" ? LockupOnDark : LockupOnLight}
      alt="golfrecruit.ai"
      className={className}
    />
  );
}
